<template>
  <div class="page__survey_analysis a-page">
    <div style="padding: 10px 20px">
      <el-tag v-if="atosa_device === 'web'" style="margin-bottom: 30px" type="">
        {{ $t('tool.download_app_title') }}
        &nbsp;&nbsp;
        <a href="javascript:void(0)" style="text-decoration: underline !important;"
           @click="EB.$emit('show_download_app_dialog')">{{ $t('tool.download_app') }}!</a>
      </el-tag>

      <el-row>
        <el-col :sm="12">
          <el-tabs v-model="tab">
            <el-tab-pane :label="$t('menu.shop_analysis')" name="first" style="padding: 0 5px">
            </el-tab-pane>
          </el-tabs>
        </el-col>
        <el-col :sm="12" class="text-right">
          <el-button size="mini" type="info" icon="el-icon-info" @click="m__show_history">
            {{ $t('base.show_saved_files') }}
          </el-button>
        </el-col>
      </el-row>
      <br>

      <div>
        <el-row>
          <strong class="text-danger" style="font-size: 13px">* {{ $t('tool.analysis_note') }}.</strong>
          <br>
          <br>
          <br>
          <el-col :sm="8">
            <div style="width: 100%; display: flex; margin-left: 5px" class="merge-select-input">
              <el-select size="mini" style="width: 25%" :value="region" :disabled="loading.change_region"
                         @change="m__change_region">
                <el-option v-for="shop in global_shops" :key="shop.country" :value="shop.country" :label="shop.name">
                </el-option>
              </el-select>
              <el-input size="mini" v-model="shop_url" :placeholder="$t('tool.input_link')"
                        @keyup.enter.native="m__enter_input" style="width: 75%" class="input" clearable>
              </el-input>
            </div>
          </el-col>
          <el-col :sm="16" style="padding-left: 10px">
            <el-button size="mini" icon="el-icon-search" type="primary" :loading="loading.get_products"
                       @click="m__get_products">{{ $t('base.analyze') }}
            </el-button>

            <el-button size="mini" icon="el-icon-s-claim" type="success"
                       :disabled="!product_list.length || loading.get_products"
                       @click="m__show_save_shop" :loading="loading.save_shop">{{ $t('base.save_file') }}
            </el-button>

            <el-button size="mini" icon="el-icon-download" type="info"
                       :disabled="!product_list.length || loading.get_products"
                       @click="m__show_download_excel">{{ $t('base.download_excel') }}
            </el-button>
          </el-col>
        </el-row>

        <br>
        <br>

        <div class="line-metrics">
          <div class="metric-item">
            <div class="metric-title">{{ $t('metric.total_sold') }}</div>
            <div class="metric-value"><span>{{ m__short_value(historical_sold) }}</span></div>
          </div>
          <div class="metric-item">
            <div class="metric-title">{{ $t('base.sales') }}</div>
            <div class="metric-value"><span>{{ m__short_value(revenue) }}</span></div>
          </div>
          <div class="metric-item">
            <div class="metric-title">{{ $t('tool.aov') }}</div>
            <div class="metric-value"><span>{{ m__short_value(aov) }}</span></div>
          </div>
          <div class="metric-item">
            <div class="metric-title">{{ $t('tool.monthly_sold') }}</div>
            <div class="metric-value"><span>{{ m__short_value(sold) }}</span></div>
          </div>
          <div class="metric-item">
            <div class="metric-title">{{ $t('tool.monthly_sales') }}</div>
            <div class="metric-value"><span>{{ m__short_value(revenue_month) }}</span></div>
          </div>
          <div class="metric-item">
            <div class="metric-title">{{ $t('tool.monthly_aov') }}</div>
            <div class="metric-value"><span>{{ m__short_value(aov_month) }}</span></div>
          </div>
        </div>

        <br>
        <br>
        <el-row>
          <el-col :sm="3" style="padding-right: 20px">
            <el-select size="mini" value="" v-model="filter.page_size">
              <el-option v-for="item in filter.pages" :key="item" :value="item" :label="item"></el-option>
            </el-select>
          </el-col>
          <el-col :sm="12">
            &nbsp;
          </el-col>
          <el-col :sm="4" class="text-right" style="padding-right: 15px">
            <el-button size="mini" @click="m__show_filter_dialog"
                       :disabled="!product_list.length || loading.get_products">
              <i class="ti-panel"></i>&nbsp; Bộ lọc
              <template v-if="product_filter2.some(i => i.value)">
                <span class="text-success">[ON]</span>
              </template>
              <template v-else>
                <span class="text-danger">[OFF]</span>
              </template>
            </el-button>
          </el-col>
          <el-col :sm="5">
            <el-input size="mini" v-model="filter.keyword" :placeholder="$t('input.placeholder')"
                      prefix-icon="el-icon-search"></el-input>
          </el-col>
        </el-row>

        <div v-if="type === 'all'">
          <div id="double-scroll-wrapper" style="position: fixed; z-index: 2000; bottom: 1px;">
            <div id="double-scroll-bar">
            </div>
          </div>

          <el-table id="main-table" :data="list_display"
                    style="width: 100%; overflow-x: scroll" @sort-change="m__sort_change">
            <el-table-column width="65px">
              <template slot-scope="scope">
                <div style="height: 5px"></div>
                <img :src="SHOPEE_IMAGE(scope.row.image)" alt="logo"
                     style="width:35px; height: 35px;">
                <div style="height: 5px"></div>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('product.name')"
              width="250"
              prop="name"
              show-tooltip-when-overflow>
              <template slot-scope="scope">
                <a :href="m__create_product_link(scope.row)" target="_blank">{{ scope.row.name }}</a>
              </template>
            </el-table-column>
            <el-table-column
              width="130px"
              :label="$t('base.variations')">
              <template slot-scope="scope">
                <el-button type="text" @click="m__show_models_dialog(scope.row)" :loading="loading_get_models"
                           :disabled="loading.get_products">
                  <strong class="text-primary">{{ $t('tool.show_variations') }}</strong>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('base.price')" sortable
              prop="price_max">
              <template slot-scope="scope">
                {{ scope.row.display_price | currency }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('base.discount')"
              prop="discount" sortable>
            </el-table-column>
            <el-table-column
              :label="$t('base.sold')"
              prop="historical_sold"
              width="120" sortable>
            </el-table-column>
            <el-table-column
              :label="$t('tool.monthly_sold')"
              width="140"
              prop="sold" sortable>
            </el-table-column>
            <el-table-column
              :label="$t('base.stock')"
              prop="stock" sortable>
            </el-table-column>
            <el-table-column
              :label="$t('base.created_at')"
              width="130" prop="ctime" sortable>
              <template slot-scope="scope">
                {{ scope.row.ctime * 1000 | moment }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('tool.day_number_creation')"
              width="130" prop="ctime" sortable>
              <template slot-scope="scope">
                {{ m__get_day(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('base.sales')"
              width="120" prop="revenue"
              sortable>
              <template slot-scope="scope">
                {{ scope.row.price_max / 100000 * scope.row.historical_sold | currency }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('tool.monthly_sales')"
              width="160" prop="revenue_month"
              sortable>
              <template slot-scope="scope">
                {{ scope.row.price_max / 100000 * scope.row.sold | currency }}
              </template>
            </el-table-column>
            <el-table-column
              label="Comment"
              width="120" prop="comment" sortable>
              <!--<template slot-scope="scope">
                {{ Math.round(scope.row.comment) }}
              </template>-->
            </el-table-column>
            <el-table-column
              label="Like"
              prop="liked_count" sortable>
            </el-table-column>
            <el-table-column
              label="5 Star"
              width="100" prop="item_rating.rating_count[5]" sortable>
            </el-table-column>
            <el-table-column
              label="Rating"
              width="100" prop="rating" sortable>
              <template slot-scope="scope">
                {{ Math.round(scope.row.item_rating.rating_star) }}
              </template>
            </el-table-column>
            <el-table-column
              label="5 Star"
              width="100" prop="item_rating.rating_count[5]">
            </el-table-column>
            <el-table-column
              label="4 Star"
              width="100" prop="item_rating.rating_count[4]">
            </el-table-column>
            <el-table-column
              label="3 Star"
              width="100" prop="item_rating.rating_count[3]">
            </el-table-column>
            <el-table-column
              label="2 Star"
              width="100" prop="item_rating.rating_count[2]">
            </el-table-column>
            <el-table-column
              label="1 Star"
              width="100" prop="item_rating.rating_count[1]">
            </el-table-column>
          </el-table>
          <el-pagination id="main-pagination"
                         :current-page.sync="filter.current_page"
                         :page-size="filter.page_size"
                         layout="total, prev, pager, next"
                         :total="list_true.length">
          </el-pagination>
        </div>

        <div v-if="type === 'detail'">
          <el-table
            :data="product_list_detail"
            style="width: 100%; margin-top: 10px; overflow-x: scroll">
            <el-table-column
              label="#"
              type="index"
              width="60">
            </el-table-column>
            <el-table-column
              :label="$t('product.name')"
              width="150"
              prop="name"
              show-tooltip-when-overflow>
              <template slot-scope="scope">
                <a :href="m__create_product_link(scope.row)" target="_blank">{{ scope.row.name }}</a>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('base.variation_name')"
              width="150">
              <template slot-scope="scope">
                {{ scope.row.model ? scope.row.model.name : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              label="Price"
              width="150"
              prop="model.price">
              <template slot-scope="scope">
                {{ scope.row.model ? scope.row.model.price / 100000 : 0 | currency }} ₫
              </template>
            </el-table-column>
            <el-table-column
              label="Discount"
              width="150"
              prop="discount">
              <template slot-scope="scope">{{ scope.row.discount || '' }}</template>
            </el-table-column>
            <el-table-column
              :label="$t('base.sold')"
              width="150"
              prop="model.sold">
              <template slot-scope="scope">{{ scope.row.model ? scope.row.model.sold : 0 }}</template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <el-dialog width="1200px" :close-on-click-modal="false" :visible.sync="show_history"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <br>
        <strong>{{ $t('base.saved_files') }}</strong>
        <br>
        <br>
        <el-row>
          <el-col :sm="4">
            <el-select size="mini" v-model="history_filter.selected_shop" filterable>
              <el-option value="" :label="$t('shop.all')"></el-option>
              <el-option v-for="(item, index) in history_shop" :key="index" :value="item.shopId"
                         :label="item.shopName"></el-option>
            </el-select>
          </el-col>
          <el-col :sm="1">&nbsp;</el-col>
          <el-col :sm="4">
            <el-select size="mini" v-model="history_filter.type">
              <el-option value="" :label="$t('base.all')"></el-option>
              <el-option value="MANUAL" :label="$t('tool.manual_save')"></el-option>
              <el-option value="AUTO" :label="$t('tool.auto_save')"></el-option>
            </el-select>
          </el-col>
          <el-col :sm="1">&nbsp;</el-col>
          <el-col :sm="4">
            <el-input size="mini" v-model="history_filter.keyword" :placeholder="$t('input.placeholder')"></el-input>
          </el-col>
          <el-col :sm="10">&nbsp;</el-col>
        </el-row>
        <el-table
          v-loading="loading.get_history"
          :data="c__history_list_display"
          style="width: 100%; margin-top: 10px; overflow-x: scroll">
          <el-table-column
            label="#"
            type="index"
            width="40">
          </el-table-column>
          <el-table-column
            :label="$t('shop.name')"
            prop="shopName">
          </el-table-column>
          <el-table-column
            :label="$t('base.filename')"
            prop="fileName"
            show-tooltip-when-overflow>
          </el-table-column>
          <el-table-column
            :label="$t('tool.save_type')"
            prop="typeSave">
            <template slot-scope="scope">
              <strong v-if="scope.row.typeSave === 'MANUAL'" class="text-success">{{ $t('base.manual') }}</strong>
              <strong v-if="scope.row.typeSave === 'AUTO'" class="text-warning">{{ $t('base.automatic') }}</strong>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('base.created_at')"
            prop="savedAt">
            <template slot-scope="scope">
              {{ m__format_date(scope.row.savedAt) }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('base.action')"
            width="300px">
            <template slot-scope="scope">
              <el-button size="mini" icon="el-icon-download" type="info"
                         @click="m__show_download_excel_history(scope.row)">{{ $t('base.download_excel') }}
              </el-button>

              <el-button size="mini" type="primary" @click="m__show_history_detail(scope.row)">
                {{ $t('base.see_detail') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page.sync="history_filter.current_page"
          :page-size="history_filter.page_size"
          layout="total, prev, pager, next"
          :total="c__history_list_true.length">
        </el-pagination>
      </div>
    </el-dialog>

    <el-dialog width="1200px" :close-on-click-modal="false" :visible.sync="show_detail"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <br>
        <el-row>
          <el-col :sm="16">
            <p>{{ $t('base.filename') }}: <strong>{{ selected_history.fileName }}</strong></p>

            <el-input size="mini" style="width: 200px" :placeholder="$t('input.placeholder')"
                      v-model="product_filter.keyword"></el-input>
          </el-col>
          <el-col :sm="8" class="text-right">
            <el-button size="mini" icon="el-icon-download" type="info"
                       @click="m__show_download_excel_detail_history">{{ $t('base.download_excel') }}
            </el-button>
          </el-col>
        </el-row>

        <el-table
          :data="history_product_list_display" @sort-change="m__history_sort_change"
          style="width: 100%; margin-top: 10px; overflow-x: scroll">
          <el-table-column
            label="#"
            type="index"
            width="60">
          </el-table-column>
          <el-table-column
            :label="$t('product.name')"
            width="150"
            prop="productName"
            show-tooltip-when-overflow>
            <template slot-scope="scope">
              <a :href="m__create_product_link2(scope.row)" target="_blank">{{ scope.row.productName }}</a>
            </template>
          </el-table-column>
          <el-table-column
            width="130px"
            :label="$t('base.variations')">
            <template slot-scope="scope">
              <el-button type="text" @click="m__show_models_dialog(scope.row)">
                <strong class="text-primary">{{ $t('tool.show_variations') }}</strong>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('base.price')" sortable
            prop="priceMax">
            <template slot-scope="scope">
              {{ scope.row.priceMax / 100000 | currency }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('base.discount')"
            prop="discount" sortable>
          </el-table-column>
          <el-table-column
            :label="$t('base.sold')"
            prop="historicalSold"
            width="120" sortable>
          </el-table-column>
          <el-table-column
            :label="$t('tool.monthly_sold')"
            width="140"
            prop="sold" sortable>
          </el-table-column>
          <el-table-column
            :label="$t('base.stock')"
            prop="stock" sortable>
          </el-table-column>
          <el-table-column
            :label="$t('base.created_at')"
            width="130" prop="ctime" sortable>
            <template slot-scope="scope">
              {{ scope.row.ctime * 1000 | moment }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('tool.day_number_creation')"
            width="130" prop="ctime" sortable>
            <template slot-scope="scope">
              {{ m__get_day(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('base.sales')"
            width="120" prop="revenue"
            sortable>
            <template slot-scope="scope">
              {{ scope.row.priceMax / 100000 * scope.row.historicalSold | currency }}
            </template>
          </el-table-column>
          <el-table-column
            label="Comment"
            width="120" prop="comment" sortable>
          </el-table-column>
          <el-table-column
            label="Like"
            prop="liked_count" sortable>
          </el-table-column>
          <el-table-column
            label="Rating"
            width="100" prop="rating" sortable>
            <template slot-scope="scope">
              {{ Math.round(scope.row.rating_star) }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page.sync="product_filter.current_page"
          :page-size="product_filter.page_size"
          layout="total, prev, pager, next"
          :total="history_product_list_true.length">
        </el-pagination>
      </div>
    </el-dialog>

    <el-dialog width="900px" :close-on-click-modal="false" :visible.sync="show_dialog.models"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <br>
        <strong>{{ $t('base.product') }}: {{ selected_product.name }}</strong>

        <br>
        <el-table
          v-loading="loading.get_models"
          :data="selected_models"
          style="width: 100%; margin-top: 10px; overflow-x: scroll">
          <el-table-column
            label="#"
            type="index"
            width="40">
          </el-table-column>
          <el-table-column
            :label="$t('base.variations')"
            prop="name">
          </el-table-column>
          <el-table-column
            :label="$t('base.price')"
            prop="price" sortable>
            <template slot-scope="scope">
              {{ scope.row.price / 100000 | currency }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('base.sold')"
            prop="sold" sortable>
            <template slot-scope="scope">
              {{ scope.row.sold | currency }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('base.sales')"
            prop="gmv" sortable>
            <template slot-scope="scope">
              {{ scope.row.gmv | currency }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('base.stock')"
            prop="price">
            <template slot-scope="scope">
              {{ scope.row.stock | currency }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_filter" :close-on-click-modal="false" width="600px">
      <div slot="title" style="padding:10px">
        <el-table :data="product_filter2">
          <el-table-column :label="$t('base.column')" prop="label">
            <template slot-scope="scope">
                <span style="font-weight: 700" :class="scope.row.value ? 'text-success' : ''">{{
                    scope.row.label
                  }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.expression')" prop="expression" width="100px">
            <template slot-scope="scope">
              <el-select class="full-w" size="mini" v-model="scope.row.expression">
                <el-option label=">" value=">"></el-option>
                <el-option label="<" value="<"></el-option>
                <el-option label="=" value="==="></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.value')" prop="value" width="120px">
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.value" type="number"></el-input>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.optional')" width="100px" align="right">
            <template slot-scope="scope">
              <div style="height: 3px"></div>
              <el-button size="mini" type="danger"
                         @click="() => {scope.row.value = null; scope.row.expression = '>'}">Reset
              </el-button>
              <div style="height: 3px"></div>
            </template>
          </el-table-column>
        </el-table>

        <br><br>
        <div class="text-right">
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="m__delete_filter">
            {{ $t('base.delete_filter') }}
          </el-button>
          <el-button size="mini" type="primary" icon="el-icon-check" @click="m__start_filter">
            {{ $t('base.execute') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="notify" :close-on-click-modal="false"
               custom-class="no-body"
               width="600px">
      <div slot="title" style="padding:10px">
        <div style="text-align: center">
          <strong style="font-size: 18px">{{ $t('base.notice') }}</strong>
        </div>

        <div style="margin-top: 30px; font-size: 14px; line-height: 25px">
          {{ $t('tool.download_app_message') }}
        </div>

        <div style="margin-top: 40px; text-align: center">
          <el-button type="primary" size="small" @click="EB.$emit('show_download_app_dialog'); notify = false">
            {{ $t('tool.download_app') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import {drop as _drop, filter as _filter, take as _take, uniqBy as _uniqBy} from 'lodash'
import history from './history.vue'
import {global_shops} from "../../addon/global_config";

export default {
  name: 'page__survey_analysis',

  components: {
    history
  },

  data() {
    return {
      tab: 'first',
      product_filter2: [
        {
          label: this.$t('base.price'),
          key: 'display_price',
          checked: true,
          expression: '>',
          value: null
        },
        {
          label: this.$t('base.discount'),
          key: 'discount',
          checked: true,
          expression: '>',
          value: null
        },
        {
          label: this.$t('base.sold'),
          key: 'historical_sold',
          checked: true,
          expression: '>',
          value: null
        },
        {
          label: this.$t('tool.monthly_sold'),
          key: 'sold',
          checked: true,
          expression: '>',
          value: null
        },
        {
          label: this.$t('base.stock'),
          key: 'stock',
          checked: true,
          expression: '>',
          value: null
        }
      ],
      type: 'all',
      file_name: '',
      filter: {
        pages: [10, 20, 50],
        page_size: 20,
        current_page: 0,
        keyword: '',
        total_record: 0
      },
      shop_url: '',
      shop_id: '',
      shop_name: '',
      shop_info: {},
      product_list: [],
      clone_list: [],
      product_list_detail: [],
      clone_list_detail: [],
      show_dialog: {
        shop: false,
        models: false
      },
      loading: {
        get_products: false,
        save_shop: false,
        add_config: false,
        get_detail: false,
        get_history: false,
        shop: false,
        get_models: false,
        change_region: false
      },
      show_history: false,
      history_shop: [],
      history_list: [],
      history_filter: {
        selected_shop: '',
        page_size: 12,
        current_page: 0,
        keyword: '',
        type: ''
      },
      history_product: [],
      history_product_clone: [],
      show_detail: false,
      selected_history: {},
      product_filter: {
        selected_shop: '',
        page_size: 12,
        current_page: 0,
        keyword: ''
      },
      show_config: false,
      show_config2: false,
      form_config_auto: {
        shopId: '',
        shopUrl: '',
        mipeeUserId: '',
        hour: 1
      },
      auto_list: [],
      time_list: [],
      shop_url_list: [],
      bought_package: [],
      selected_product: {},
      selected_models: [],
      show_filter: false,

      sort_option: {
        order: null,
        prop: null
      },
      is_destroyed: false,

      historical_sold: 0,
      revenue: 0,
      aov: 0,
      sold: 0,
      revenue_month: 0,
      aov_month: 0,
      view_count: 0,

      interval: null,

      loading_get_models: false,

      channel: 'shopee_analysis',
      feature: 'shop_analysis',
      limit_request_number: 0,
      current_request_number: 0,

      notify: false,

      region: 'vn',
      global_shops: global_shops,
    }
  },

  async beforeMount() {
    this.notify = this.atosa_device === 'web'

    for (let i = 0; i <= 23; i++) {
      this.time_list.push(i)
    }

    await this.m__try_get_bought_package()
    await this.m__get_shop_url()

    await this.m__get_limit_request_number()
  },

  beforeDestroy() {
    this.is_destroyed = true

    clearInterval(this.interval)
    const dashboard_wrapper = document.getElementById('dashboard-wrapper')
    dashboard_wrapper.onscroll = () => {
    }
  },

  computed: {
    list_true() {
      let result = this.clone(this.product_list)

      if (this.sort_option.order) {
        const {
          order,
          prop
        } = this.sort_option
        if (prop === 'price_max') {
          order === 'ascending' && result.sort((a, b) => a.price_max - b.price_max)
          order === 'descending' && result.sort((a, b) => b.price_max - a.price_max)
        }

        if (prop === 'discount') {
          order === 'ascending' && result.sort((a, b) => Math.floor(a.discount ? a.discount.replace('%', '') : 0) - Math.floor(b.discount ? b.discount.replace('%', '') : 0))
          order === 'descending' && result.sort((a, b) => Math.floor(b.discount ? b.discount.replace('%', '') : 0) - Math.floor(a.discount ? a.discount.replace('%', '') : 0))
        }

        if (prop === 'historical_sold') {
          order === 'ascending' && result.sort((a, b) => a.historical_sold - b.historical_sold)
          order === 'descending' && result.sort((a, b) => b.historical_sold - a.historical_sold)
        }

        if (prop === 'sold') {
          order === 'ascending' && result.sort((a, b) => a.sold - b.sold)
          order === 'descending' && result.sort((a, b) => b.sold - a.sold)
        }

        if (prop === 'stock') {
          order === 'ascending' && result.sort((a, b) => a.stock - b.stock)
          order === 'descending' && result.sort((a, b) => b.stock - a.stock)
        }

        if (prop === 'ctime') {
          order === 'ascending' && result.sort((a, b) => a.ctime - b.ctime)
          order === 'descending' && result.sort((a, b) => b.ctime - a.ctime)
        }

        if (prop === 'revenue') {
          // scope.row.price_max / 100000 * scope.row.historical_sold
          order === 'ascending' && result.sort((a, b) => a.revenue - b.revenue)
          order === 'descending' && result.sort((a, b) => b.revenue - a.revenue)
        }

        if (prop === 'revenue_month') {
          // scope.row.price_max / 100000 * scope.row.historical_sold
          order === 'ascending' && result.sort((a, b) => a.revenue_month - b.revenue_month)
          order === 'descending' && result.sort((a, b) => b.revenue_month - a.revenue_month)
        }

        if (prop === 'comment') {
          // scope.row.price_max / 100000 * scope.row.historical_sold
          order === 'ascending' && result.sort((a, b) => a.comment - b.comment)
          order === 'descending' && result.sort((a, b) => b.comment - a.comment)
        }

        if (prop === 'liked_count') {
          // scope.row.price_max / 100000 * scope.row.historical_sold
          order === 'ascending' && result.sort((a, b) => a.liked_count - b.liked_count)
          order === 'descending' && result.sort((a, b) => b.liked_count - a.liked_count)
        }

        if (prop === 'rating') {
          // scope.row.price_max / 100000 * scope.row.historical_sold
          order === 'ascending' && result.sort((a, b) => a.item_rating.rating_star - b.item_rating.rating_star)
          order === 'descending' && result.sort((a, b) => b.item_rating.rating_star - a.item_rating.rating_star)
        }

        if (prop === 'view_count') {
          order === 'ascending' && result.sort((a, b) => a.view_count - b.view_count)
          order === 'descending' && result.sort((a, b) => b.view_count - a.view_count)
        }

        if (prop === 'conversion_rate') {
          order === 'ascending' && result.sort((a, b) => a.conversion_rate - b.conversion_rate)
          order === 'descending' && result.sort((a, b) => b.conversion_rate - a.conversion_rate)
        }
      }

      const words = this.remove_unicode(this.filter.keyword)
      // return _filter(result, item => JSON.stringify(item).includes(words))
      return _filter(result, item => item.name && this.remove_unicode(item.name.normalize()).includes(words))
    },

    list_display() {
      const limit = this.filter.page_size
      const skip = limit * (this.filter.current_page - 1)

      return _take(_drop(this.list_true, skip), limit)
    },

    c__history_list_true() {
      let result = this.history_list

      if (this.history_filter.selected_shop) {
        result = _filter(result, i => i.shopId === this.history_filter.selected_shop)
      }

      if (this.history_filter.type) {
        result = _filter(result, i => i.typeSave === this.history_filter.type)
      }

      const words = this.remove_unicode(this.history_filter.keyword)
      return _filter(result, item => JSON.stringify(item).includes(words))
    },

    c__history_list_display() {
      const limit = this.history_filter.page_size
      const skip = limit * (this.history_filter.current_page - 1)

      return _take(_drop(this.c__history_list_true, skip), limit)
    },

    history_product_list_true() {
      const words = this.remove_unicode(this.product_filter.keyword)
      // return _filter(this.history_product, item => JSON.stringify(item).includes(words))
      return _filter(this.history_product, item => item.productName && this.remove_unicode(item.productName.normalize()).includes(words))
    },

    history_product_list_display() {
      const limit = this.product_filter.page_size
      const skip = limit * (this.product_filter.current_page - 1)

      return _take(_drop(this.history_product_list_true, skip), limit)
    }
  },

  methods: {
    async m__change_region(e) {
      this.loading.change_region = true

      console.log(e)

      // try {
      //   await this.execute_browser()
      // } catch (e) {
      //   console.error(e)
      // }

      this.loading.change_region = false
    },

    async m__get_limit_request_number() {
      const package_found = this.$store.state.package.extend_package.find(i => i.channel === this.channel)
      if (package_found && package_found.package.extra_data.request_limit) {
        this.limit_request_number = package_found && package_found.package.extra_data.request_limit
      }
      console.log('limit_request_number', this.limit_request_number)

      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/limit_request/get', {
        channel: this.channel,
        feature: this.feature
      }, this.cf())
      this.current_request_number = response.body.data.count
      console.log('current_request_number', this.current_request_number)
    },

    m__generate_scrollbar() {
      this.$nextTick(() => {
        try {
          const dashboard_wrapper = document.getElementById('dashboard-wrapper')
          const main_pagination = document.getElementById('main-pagination')

          const main_table = document.querySelector('div#main-table')
          const main_table_wrapper = document.querySelector('div#main-table div.el-table__body-wrapper')
          const scrollbar = document.getElementById('double-scroll-bar')

          const scrollbar_wrapper = document.getElementById('double-scroll-wrapper')
          scrollbar_wrapper.style.width = main_table.scrollWidth + 'px'

          scrollbar.appendChild(document.createElement('div'))
          scrollbar.style.overflow = 'auto'
          scrollbar.style.overflowY = 'hidden'
          scrollbar.firstChild.style.width = main_table_wrapper.scrollWidth + 'px'
          this.interval = setInterval(() => {
            scrollbar_wrapper.style.width = main_table.scrollWidth + 'px'
            scrollbar.firstChild.style.width = main_table_wrapper.scrollWidth + 'px'
          }, 1000)
          scrollbar.firstChild.style.paddingTop = '1px'
          scrollbar.firstChild.appendChild(document.createTextNode('\xA0'))
          scrollbar.onscroll = () => {
            main_table_wrapper.scrollLeft = scrollbar.scrollLeft
          }
          main_table_wrapper.onscroll = () => {
            scrollbar.scrollLeft = main_table_wrapper.scrollLeft
          }

          const bounding_main_pagination = () => {
            const rect = main_pagination.getBoundingClientRect()
            const elem_top = rect.top
            const is_visible = elem_top <= window.innerHeight
            if (is_visible) {
              scrollbar_wrapper.style.zIndex = '-1'
            } else {
              scrollbar_wrapper.style.zIndex = '2000'
            }
          }
          bounding_main_pagination()

          dashboard_wrapper.onscroll = () => {
            bounding_main_pagination()
          }
        } catch (e) {
        }
      })
    },

    m__short_value(value, is_percent) {
      if (this.loading.get_products) return '-'

      if (!value) return '0'
      if (!Number(value)) return '0.00'
      if (!is_percent) value = Math.floor(value)

      const one_thousand = 1000
      const one_million = one_thousand * one_thousand
      const one_billion = one_million * one_thousand

      let result = ''
      if (value >= one_billion) {
        result = `${(value / one_billion).toFixed(1)}b`
      } else if (value >= one_million) {
        result = `${(value / one_million).toFixed(1)}m`
      } else if (value >= one_thousand) {
        result = `${(value / one_thousand).toFixed(1)}k`
      } else {
        result = value
      }

      return `${result} ${is_percent ? '%' : ''}`
    },

    m__is_survey() {
      const survey = this.$store.state.package && this.$store.state.package.extend_package && this.$store.state.package.extend_package.find(i => i.package && i.package.channel === 'shopee_marketing_survey')
      if (survey) {
        return moment().isBefore(moment(new Date(survey.license_to)), 's')
      } else {
        return false
      }
    },

    m__is_shopee_analysis() {
      const survey = this.$store.state.package && this.$store.state.package.extend_package && this.$store.state.package.extend_package.find(i => i.package && i.package.channel === 'shopee_analysis')
      if (survey) {
        return moment().isBefore(moment(new Date(survey.license_to)), 's')
      } else {
        return false
      }
    },

    m__check_analysis_license() {
      // console.log(this.bought_package)
      // console.log(this.shop_url_list)

      if (this.bought_package.some(i => i.channel === 'shopee_marketing_analysis')) {
        return true
      } else {
        for (const item of this.shop_url_list) {
          if (moment().isSameOrBefore(moment(new Date(item.expr_time)), 's')) {
            return true
          }
        }

        return false
      }
    },

    m__show_filter_dialog() {
      this.show_filter = true
    },

    m__delete_filter() {
      this.product_list = [...this.clone_list]
      this.product_filter2.forEach(i => {
        i.value = null
        i.expression = '>'
      })
      this.show_filter = false
    },

    m__start_filter() {
      this.product_list = [...this.clone_list]
      let any_change = false
      for (const item of this.product_filter2) {
        if (item.value) {
          any_change = true
          this.product_list = this.product_list.filter(i => i[item.key] && eval(`${i[item.key]}
          ${item.expression}
          ${item.value}`))
        }
      }
      if (!any_change) {
        this.product_list = [...this.clone_list]
      }
      this.show_filter = false
    },

    async m__show_models_dialog(product) {
      this.selected_product = product
      this.selected_models = []

      if (!product.get_models) {
        this.loading_get_models = true
        try {
          // const response = await this.get_item({shop_id: product.shopid, item_id: product.itemid})
          const response = await this.xget_shopee(`/api/v4/pdp/get_pc?shop_id=${product.shopid}&item_id=${product.itemid}&detail_level=0`, {
            "antiFraudConfig": {
              "antiCrawler": {
                "appKey": "PDP.PC",
                "shouldReplaceHistory": true,
                "redirectType": "1"
              },
              "deviceFingerPrint": {},
              "apiProtection": {}
            }
          })
          if (!response || !response.data || !response.data.data || !response.data.data.data) {
            this.ntf_w(this.$t('tool.cannot_get_data'))
            this.loading_get_models = false
            return
          }

          // console.log(response)
          for (const item of response.data.data.data.item.models) {
            item.gmv = item.price / 100000 * item.sold
          }
          this.selected_models = response.data.data.data.item.models
          this.show_dialog.models = true
        } catch (e) {
          console.error(e)
        } finally {
          this.loading_get_models = false
        }
      }
    },

    async m__try_get_bought_package() {
      const resp = await this.$http.get(this.API.store_get_bought_package, this.cf())
      this.bought_package = resp.body.data.bought_package.filter(i => ['shopee_marketing_analysis'].includes(i.channel))
    },

    m__get_shop_not_expr() {
      return this.shop_url_list.filter(i => !this.m__is_expr(i)).length
    },

    m__get_total() {
      return this.bought_package.length
    },

    m__convert_date(data) {
      return moment(new Date(data.expr_time)).format('DD-MM-YYYY HH:mm')
    },

    m__is_expr(data) {
      return moment().isAfter(moment(data.expr_time))
    },

    async m__get_shop_url() {
      const resp = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/analysis/shop', this.cf())
      this.shop_url_list = resp.body.data
    },

    async m__enter_input() {
      if (!this.loading.get_products) {
        await this.m__get_products()
      }
    },

    async m__get_products() {
      if (!this.m__check_analysis_license() && !this.m__is_survey() && !this.m__is_shopee_analysis()) {
        this.ntf_w(this.$t('tool.buy_package_message'))
        return
      }

      if (this.limit_request_number && this.current_request_number >= this.limit_request_number) {
        this.ntf_w(this.$t('tool.limit_package_message'))
        return
      }

      this.loading.get_products = true
      this.product_list = []

      try {
        const shop_name_match = this.shop_url.match(/shopee\.[a-z.]{2,6}\/[a-z0-9._]+/ig)
        if (!shop_name_match || !shop_name_match.length) {
          this.ntf_w(this.$t('tool.invalid_shop_url'))
          return
        }
        const shop_name = shop_name_match[0].split('/')[shop_name_match[0].split('/').length - 1].toLowerCase()
        if (!shop_name) {
          this.ntf_w(this.$t('tool.invalid_shop_url'))
          return
        }

        const shop_info = await this.xget_shopee(`/api/v4/shop/get_shop_base?entry_point=ShopByPDP&need_cancel_rate=true&request_source=shop_home_page&username=${shop_name}&version=1`, {
          "antiFraudConfig": {
            "antiCrawler": {
              "appKey": "Shop.PC",
              "shouldReplaceHistory": true,
              "redirectType": "1"
            },
            "deviceFingerPrint": {},
            "apiProtection": {}
          }
        })
        // console.log(shop_info)

        if (!shop_info.data.data.data) {
          this.ntf_w(`${this.$t('tool.invalid_shop_url')}: ${shop_name}`)
          return
        }

        this.shop_info = shop_info.data.data.data
        this.shop_id = shop_info.data.data.data.shopid
        this.shop_name = shop_name

        // let newest = 0
        // let response = await this.get_recommend({
        //   qs: {limit: 30, shop_id: this.shop_id, shop_name: this.shop_name, newest, cookie},
        //   device: 'website'
        // })

        let newest = 0
        let response = await this.xpost_shopee(' /api/v4/shop/rcmd_items',
          {
            "bundle": "shop_page_category_tab_main",
            "item_id": undefined,
            "shop_id": this.shop_id,
            "limit": 30,
            "offset": newest,
            "upstream": "pdp",
            "step2_upstream": "dd",
            "sort_type": 1,
            "user_behaviour": {
              "user_behaviour_list": []
            }
          },
          {
            "antiFraudConfig": {
              "antiCrawler": {
                "appKey": "Shop.PC",
                "shouldReplaceHistory": true,
                "redirectType": "1"
              },
              "deviceFingerPrint": {},
              "apiProtection": {}
            }
          }
        )
        // console.log(response)

        if (!response || !response.data || !response.data.data || !response.data.data.data || !response.data.data.data.items) {
          this.ntf_w(this.$t('tool.cannot_get_data'))
          this.loading.get_products = false
          return
        }

        this.m__generate_scrollbar()

        while (response.data.data.data.items && response.data.data.data.items.length > 0) {
          for (const item of response.data.data.data.items) {
            if (this.is_destroyed) break

            Object.assign(item, item.item_basic)
            delete item.item_basic

            item.get_models = false
            item.display_price = item.price_max / 100000
            item.revenue = item.price_max / 100000 * item.historical_sold
            item.revenue_month = item.price_max / 100000 * item.sold
            item.comment = item.item_rating.rating_count[0]

            this.product_list.push(item)

            await this.sleep(500)
          }

          // newest += 30
          // response = await this.get_recommend({
          //   qs: {limit: 30, shop_id: this.shop_id, shop_name: this.shop_name, newest, cookie},
          //   device: 'website'
          // })

          newest += 30
          response = await this.xpost_shopee(' /api/v4/shop/rcmd_items',
            {
              "bundle": "shop_page_category_tab_main",
              "shop_id": this.shop_id,
              "limit": 30,
              "offset": newest,
              "upstream": "pdp",
              "step2_upstream": "dd",
              "sort_type": 1,
              "user_behaviour": {
                "user_behaviour_list": []
              }
            },
            {
              "antiFraudConfig": {
                "antiCrawler": {
                  "appKey": "Shop.PC",
                  "shouldReplaceHistory": true,
                  "redirectType": "1"
                },
                "deviceFingerPrint": {},
                "apiProtection": {}
              }
            }
          )

          if (!response || !response.data || !response.data.data || !response.data.data.data || !response.data.data.data.items) {
            break
          }
        }

        [this.historical_sold, this.revenue, this.sold, this.revenue_month, this.view_count] = this.product_list.reduce((result, item) => {
          result[0] += item.historical_sold
          result[1] += item.revenue
          result[2] += item.sold
          result[3] += item.revenue_month
          result[4] += item.view_count

          return result
        }, [0, 0, 0, 0, 0])

        await this.m__get_sold_out()

        this.aov = this.historical_sold ? Math.floor(this.revenue / this.historical_sold) : 0
        this.aov_month = this.sold ? Math.floor(this.revenue_month / this.sold) : 0

        this.clone_list = this.product_list

        this.ntf_s(this.$t('tool.analyze_success'))

        if (this.product_list.length) {
          await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/limit_request/save', {
            channel: this.channel,
            feature: this.feature
          }, this.cf())
          await this.m__get_limit_request_number()
        }
      } catch (e) {
        console.log(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.get_products = false
      }
    },

    async m__get_sold_out() {
      // let newest = 0
      // let response = await this.request_to_shopee_with_hash({url: `https://shopee.vn/api/v4/shop/search_items?filter_sold_out=1&limit=30&offset=${newest}&order=desc&shopid=${this.shop_id}&sort_by=relevancy&use_case=4`})
      let newest = 0
      let response = await this.xget_shopee(`https://shopee.vn/api/v4/shop/search_items?filter_sold_out=1&limit=30&offset=${newest}&order=desc&shopid=${this.shop_id}&sort_by=relevancy&use_case=4`,
        {
          "antiFraudConfig": {
            "antiCrawler": {
              "appKey": "Shop.PC",
              "shouldReplaceHistory": true,
              "redirectType": "1"
            },
            "deviceFingerPrint": {},
            "apiProtection": {}
          }
        }
      )
      // console.log(response)

      while (response.data.data.items && response.data.data.items.length > 0) {
        for (const item of response.data.data.items) {
          if (this.is_destroyed) break

          Object.assign(item, item.item_basic)
          delete item.item_basic

          item.display_price = item.price_max / 100000
          item.revenue = item.price_max / 100000 * item.historical_sold
          item.revenue_month = item.price_max / 100000 * item.sold
          item.comment = item.item_rating.rating_count[0]

          this.product_list.push(item)

          await this.sleep(500)
        }

        // newest += 30
        // response = await this.request_to_shopee_with_hash({url: `https://shopee.vn/api/v4/shop/search_items?filter_sold_out=1&limit=30&offset=${newest}&order=desc&shopid=${this.shop_id}&sort_by=relevancy&use_case=4`})
        newest += 30
        response = await this.xget_shopee(`https://shopee.vn/api/v4/shop/search_items?filter_sold_out=1&limit=30&offset=${newest}&order=desc&shopid=${this.shop_id}&sort_by=relevancy&use_case=4`,
          {
            "antiFraudConfig": {
              "antiCrawler": {
                "appKey": "Shop.PC",
                "shouldReplaceHistory": true,
                "redirectType": "1"
              },
              "deviceFingerPrint": {},
              "apiProtection": {}
            }
          }
        )
      }

      [this.historical_sold, this.revenue, this.sold, this.revenue_month, this.view_count] = this.product_list.reduce((result, item) => {
        result[0] += item.historical_sold
        result[1] += item.revenue
        result[2] += item.sold
        result[3] += item.revenue_month
        result[4] += item.view_count

        return result
      }, [0, 0, 0, 0, 0])
    },

    async m__get_product_detail(itemid, shopid) {
      const response = await this.request_to_shopee_with_hash({
        url: `https://shopee.vn/api/v4/item/get?itemid=${itemid}&shopid=${shopid}`
      })
      if (response.body.data && response.body.data.data) {
        return response.body.data.data
      }

      return null
    },

    m__get_day(item) {
      return Math.abs(moment(new Date(item.ctime * 1000)).diff(moment(), 'd'))
    },

    async m__show_save_shop() {
      try {
        this.file_name = `shop-report-${this.shop_info.name}-time-${moment().format('DD_MM_YYYY HH_mm')}`

        const value = await this.$prompt(this.$t('input.filename'), this.$t('base.save_file'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          inputValue: this.file_name
        })

        if (value) {
          await this.m__save_shop()
        } else {
          this.ntf_w(this.$t('required.filename'))
        }
      } catch (e) {
      } finally {
        this.loading.save_shop = false
      }
    },

    async m__save_shop() {
      if (!this.file_name) {
        this.ntf_w(this.$t('required.filename'))
        return
      }

      this.loading.save_shop = true

      try {
        const body = {
          mipeeUserId: this.$store.state.userInfo.username,
          shopId: this.shop_id,
          shopName: this.shop_info.name,
          fileName: this.file_name,
          products: [],
          typeSave: 'MANUAL'
        }
        this.product_list.forEach(item => {
          body.products.push({
            ...item,
            productId: item.itemid,
            productName: item.name,
            priceMax: item.price_max,
            historicalSold: item.historical_sold,
            rating_star: item.item_rating.rating_star,
            comment: item.comment,
            models_string: JSON.stringify(item.models),
            json_value: JSON.stringify(item),
            rating_count_string: JSON.stringify(item.item_rating.rating_count)
          })
        })
        await this.$http.post(this.API.URL_API_SRV_3 + '/shop_report/v2', body, this.cf())
        this.ntf_s('Lưu thành công')
      } catch (e) {
        console.log(e)
      } finally {
        this.loading.save_shop = false
      }
    },

    async m__show_download_excel() {
      try {
        this.file_name = `shop-report-${this.shop_info.name}-time-${moment().format('DD_MM_YYYY HH_mm')}`

        const value = await this.$prompt(this.$t('input.filename'), this.$t('base.download_excel'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          inputValue: this.file_name
        })

        if (value) {
          await this.m__download_excel(this.product_list, false)
        } else {
          this.ntf_w(this.$t('required.filename'))
        }
      } catch (e) {
      }
    },

    async m__show_download_excel_history(history) {
      const response = await this.$http.get(this.API.URL_API_SRV_3 + '/shop_report/v2/products', {
        ...this.cf(),
        params: {
          mipeeUserId: this.$store.state.userInfo.username,
          shopReportId: history.id
        }
      })
      response.body.forEach(item => {
        item.revenue = item.priceMax / 100000 * item.historicalSold
      })

      this.history_product = this.history_product_clone = response.body
      this.selected_history = history

      await this.m__show_download_excel_detail_history()
    },

    async m__show_download_excel_detail_history() {
      try {
        this.file_name = this.selected_history.fileName

        const value = await this.$prompt(this.$t('input.filename'), this.$t('base.download_excel'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          inputValue: this.file_name
        })

        if (value) {
          await this.m__download_excel(this.history_product, true)
        } else {
          this.ntf_w(this.$t('required.filename'))
        }
      } catch (e) {
      }
    },

    async m__download_excel(products, history = false) {
      try {
        const export_url = history ? this.API.URL_API_SRV_2 + '/mipee/excel-history' : this.API.URL_API_SRV_2 + '/mipee/excel'
        const response = await this.$http.post(export_url, {
          product_list: products,
          name: this.file_name
        }, {
          ...this.cf(),
          responseType: 'blob'
        })

        const url = window.URL.createObjectURL(new Blob([response.body]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${this.file_name}.xlsx`)
        document.body.appendChild(link)
        link.click()
      } catch (e) {
        console.log(e)
      }
    },

    m__sort_change({
                     prop,
                     order
                   }) {
      // this.product_list = JSON.parse(JSON.stringify(this.clone_list))
      //
      // if (order === null) {
      //   return
      // }
      this.sort_option.order = order
      this.sort_option.prop = prop
    },

    m__create_product_link(product) {
      //const reg2 = /(\s|\/|\.|\?|#|)+/g;
      const reg = /[\s\/.?#\[\]%&]+/g
      // console.log(`https://shopee.vn/${product.name.replace(reg, '-')}-i.${this.shop_id}.${product.itemid}/`)
      return `https://shopee.vn/${product.name.replace(reg, '-')}-i.${this.shop_id}.${product.itemid}/`
    },

    m__create_product_link2(product) {
      //const reg2 = /(\s|\/|\.|\?|#|)+/g;
      const reg = /[\s\/.?#\[\]%&]+/g
      // console.log(`https://shopee.vn/${product.name.replace(reg, '-')}-i.${this.shop_id}.${product.itemid}/`)
      return `https://shopee.vn/${product.productName.replace(reg, '-')}-i.${product.shopId || this.selected_history.shopId}.${product.productId}/`
    },

    async m__show_history() {
      this.show_history = true
      this.loading.get_history = true

      const response = await this.$http.get(this.API.URL_API_SRV_3 + '/shop_report/v2', {
        ...this.cf(),
        params: {
          mipeeUserId: this.$store.state.userInfo.username
        }
      })

      this.history_list = response.body
      this.history_list.forEach(item => {
        this.history_shop.push({
          shopId: item.shopId,
          shopName: item.shopName
        })
      })

      this.history_shop = _uniqBy(this.history_shop, 'shopId')
      this.loading.get_history = false
    },

    async m__show_history_detail(history) {
      this.product_filter.keyword = ''

      const response = await this.$http.get(this.API.URL_API_SRV_3 + '/shop_report/v2/products', {
        ...this.cf(),
        params: {
          mipeeUserId: this.$store.state.userInfo.username,
          shopReportId: history.id
        }
      })
      response.body.forEach(item => {
        item.revenue = item.priceMax / 100000 * item.historicalSold
        item.models = item.models_string ? JSON.parse(item.models_string) : []
        item.conversion_rate = item.view_count && item.view_count > 0 ? +(item.sold / item.view_count * 100).toFixed(2) : 0.00
      })

      this.history_product = this.history_product_clone = response.body
      this.selected_history = history
      this.show_detail = true
    },

    m__history_sort_change({
                             prop,
                             order
                           }) {
      this.history_product = JSON.parse(JSON.stringify(this.history_product_clone))

      if (order === null) {
        return
      }

      if (prop === 'priceMax') {
        order === 'ascending' && this.history_product.sort((a, b) => a.priceMax - b.priceMax)
        order === 'descending' && this.history_product.sort((a, b) => b.priceMax - a.priceMax)
      }

      if (prop === 'discount') {
        order === 'ascending' && this.history_product.sort((a, b) => Math.floor(a.discount ? a.discount.replace('%', '') : 0) - Math.floor(b.discount ? b.discount.replace('%', '') : 0))
        order === 'descending' && this.history_product.sort((a, b) => Math.floor(b.discount ? b.discount.replace('%', '') : 0) - Math.floor(a.discount ? a.discount.replace('%', '') : 0))
      }

      if (prop === 'historicalSold') {
        order === 'ascending' && this.history_product.sort((a, b) => a.historicalSold - b.historicalSold)
        order === 'descending' && this.history_product.sort((a, b) => b.historicalSold - a.historicalSold)
      }

      if (prop === 'sold') {
        order === 'ascending' && this.history_product.sort((a, b) => a.sold - b.sold)
        order === 'descending' && this.history_product.sort((a, b) => b.sold - a.sold)
      }

      if (prop === 'stock') {
        order === 'ascending' && this.history_product.sort((a, b) => a.stock - b.stock)
        order === 'descending' && this.history_product.sort((a, b) => b.stock - a.stock)
      }

      if (prop === 'ctime') {
        order === 'ascending' && this.history_product.sort((a, b) => a.ctime - b.ctime)
        order === 'descending' && this.history_product.sort((a, b) => b.ctime - a.ctime)
      }

      if (prop === 'revenue') {
        // scope.row.price_max / 100000 * scope.row.historical_sold
        order === 'ascending' && this.history_product.sort((a, b) => a.revenue - b.revenue)
        order === 'descending' && this.history_product.sort((a, b) => b.revenue - a.revenue)
      }

      if (prop === 'comment') {
        // scope.row.price_max / 100000 * scope.row.historical_sold
        order === 'ascending' && this.history_product.sort((a, b) => a.comment - b.comment)
        order === 'descending' && this.history_product.sort((a, b) => b.comment - a.comment)
      }

      if (prop === 'liked_count') {
        // scope.row.price_max / 100000 * scope.row.historical_sold
        order === 'ascending' && this.history_product.sort((a, b) => a.liked_count - b.liked_count)
        order === 'descending' && this.history_product.sort((a, b) => b.liked_count - a.liked_count)
      }

      if (prop === 'rating') {
        // scope.row.price_max / 100000 * scope.row.historical_sold
        order === 'ascending' && this.history_product.sort((a, b) => a.item_rating.rating_star - b.item_rating.rating_star)
        order === 'descending' && this.history_product.sort((a, b) => b.item_rating.rating_star - a.item_rating.rating_star)
      }

      if (prop === 'view_count') {
        order === 'ascending' && this.history_product.sort((a, b) => a.view_count - b.view_count)
        order === 'descending' && this.history_product.sort((a, b) => b.view_count - a.view_count)
      }

      if (prop === 'conversion_rate') {
        order === 'ascending' && result.sort((a, b) => a.conversion_rate - b.conversion_rate)
        order === 'descending' && result.sort((a, b) => b.conversion_rate - a.conversion_rate)
      }
    },

    async m__get_config() {
      const response = await this.$http.get(this.API.URL_API_SRV_1 + '/auto_shop_report', {
        ...this.cf(),
        params: {
          mipeeUserId: this.$store.state.userInfo.username
        }
      })
      this.auto_list = response.body
    },

    m__format_date(date) {
      return moment(new Date(date)).format('DD-MM-YYYY HH:mm')
    }
  }
}
</script>

<style lang="scss">
.page__survey_analysis {
  padding: 5px;
}

.line-metrics {
  margin-top: 10px;
  display: flex;
  width: 100%;
  //justify-content: space-around;

  .metric-item:last-child {
    margin-right: 0 !important;
  }

  .metric-item {
    //width: 13%;
    //width: 11.5%;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: justify;
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    //border-top: 4px solid;
    //margin-right: 1.5%;
    //margin-right: 1%;
    margin-right: 8px;
    padding-top: 15px;
    padding-left: 10px;
    padding-right: 10px;
    cursor: pointer;
  }

  .metric-title {
    height: 30px;
    font-size: 13px !important;
    line-height: 15px !important;
    color: #666;
    font-weight: bold;
  }

  .metric-value {
    margin-top: 10px;
    margin-bottom: 15px;

    span {
      font-size: 22px !important;
      line-height: 24px !important;
      color: #333;
      font-weight: bold;
    }
  }
}

.circle {
  margin-right: 5px;
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/pages/tool/analysis.vue